module.exports = __webpack_public_path__ + "img/process-submit.943ffb5b.jpg";